<template>
  <div>
    <div v-if="render === 'protocol'">
      <div class="protocol-card" v-for="item in items" :key="item.id">
        <div class="protocol-header">
          <div class="protocol-title">
            {{ item.name || item.businessName || item.prescriptionName }}
          </div>
        </div>
        <div class="protocol-line" v-if="item.efficacy">功效：{{ item.efficacy }}</div>
        <div class="protocol-actions">
          <a-button @click="emitSelectProtocol(item)">选用</a-button>
        </div>
      </div>
    </div>
    <div v-else-if="render === 'medicine'">
      <div class="medicine-item" v-for="item in items" :key="item.skuId">
        <img class="medicine-img" :src="item.imageUrlList?.[0]" alt="" />
        <div class="medicine-info">
          <div class="medicine-name">
            {{ item.skuName || item.name || item.prescriptionName }}
          </div>
          <div class="medicine-box">
            <div class="medicine-left">
              <div class="medicine-store">{{ item.storeName }}</div>
              <div class="medicine-price">
                <span class="medicine-unit">¥</span>
                {{ item.salePrice }}
              </div>
            </div>
            <div class="medicine-right">
              <a-button
                class="medicine-action"
                type="default"
                size="small"
                @click="emitSelectSku(item)"
              >
                选用
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="recommend-card" v-for="item in items" :key="item.id">
        <div class="recommend-main">
          <!-- <div class="recommend-title">{{ item.businessName }}</div> -->
          <div class="recommend-list">
            <div
              class="recommend-row"
              v-for="(drug, index) in item.recommendedDetailVOList || []"
              :key="drug.skuId || index"
            >
              <span class="recommend-name">{{ drug.skuName }}</span>
              <span class="recommend-count">
                x{{ (drug.quantity || 1) * getRecommendMultiplier(item) }}
              </span>
            </div>
            <div
              class="recommend-row"
              v-for="(agreement, index) in item.prescriptionVOList || []"
              :key="agreement.prescriptionSn || index"
            >
              <span class="recommend-name">
                {{ agreement.prescriptionName || agreement.name || '协定方' }}
              </span>
              <span class="recommend-count">
                x{{ (agreement.quantity || 1) * getRecommendMultiplier(item) }}
              </span>
            </div>
            <div class="recommend-action">
              <a-button @click="emitSelectRecommend(item)">选用</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  render: {
    type: String,
    default: 'medicine'
  },
  getRecommendMultiplier: {
    type: Function,
    default: () => 1
  }
})

const emit = defineEmits(['select-sku', 'select-protocol', 'select-recommend'])

const emitSelectSku = item => {
  emit('select-sku', item)
}

const emitSelectProtocol = item => {
  emit('select-protocol', item)
}

const emitSelectRecommend = item => {
  emit('select-recommend', item)
}
</script>

<style scoped lang="scss">
.medicine-item {
  display: flex;
  gap: 12px;
  border-radius: 8px;
  background: #f7f8fb;
  padding: 16px;
  margin-bottom: 12px;
}

.medicine-item:last-child {
  margin-bottom: 0;
}

.medicine-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  background: #fff;
  margin-right: 12px;
}

.medicine-info {
  flex: 1;
  min-width: 0;
}

.medicine-name {
  font-weight: 500;
  font-size: 16px;
  color: #1c1c1c;
  overflow: hidden;
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.medicine-box {
  display: flex;
  justify-content: space-between;
  .medicine-left {
    flex: 1;
  }
  .medicine-right {
    display: flex;
    flex-direction: column-reverse;
  }
}

.medicine-store {
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  margin-top: 4px;
}

.medicine-price {
  color: #f45959;
  font-size: 18px;
  font-weight: 600;
  margin-top: 14px;
  .medicine-unit {
    font-weight: 500;
    font-size: 12px;
  }
}

.medicine-action {
  border-radius: 6px;
  padding: 0 12px;
  height: 28px;
}

::v-deep(.medicine-action.ant-btn) {
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  border-color: #1677ff;
  color: #1677ff;
  background-color: #f7f8fb;
}

.recommend-card {
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ffe4c4;
  background: #fff7ef;
  margin-bottom: 12px;
}

.recommend-title {
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 6px;
}

.recommend-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.recommend-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #333;
}

.recommend-name {
  flex: 1;
  min-width: 0;
  font-weight: 400;
  font-size: 14px;
  color: #1c1c1c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recommend-count {
  margin-left: 12px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.recommend-action {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 11px;
}

.protocol-card {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #ffe4c4;
  background: #fff7ef;
  margin-bottom: 12px;
}

.protocol-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.protocol-title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.protocol-price {
  font-size: 12px;
  color: #999;
}

.protocol-line {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}

.protocol-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
.recommend-action,
.protocol-actions {
  ::v-deep(.ant-btn) {
    height: 36px;
    padding: 0 22px;
    border-radius: 8px;
    background-image: linear-gradient(180deg, #fef8ee 0%, #fed7b1 100%);
    border: 1px solid #e6cabf4d;
    font-weight: 500;
    font-size: 14px;
    color: #8c563f;
  }
}
</style>
